import { action } from 'typesafe-actions';
import { IToast, Types } from './types';

export const addToast = (toast: IToast) => action(Types.ADD_TOAST, { toast });
export const removeToast = (toast: IToast) =>
  action(Types.REMOVE_TOAST, { toast });
